import React from 'react';
import UploadZone from '../components/UploadZone';
import SEO from '../components/SEO';
import { useNavigate, Link } from 'react-router-dom';
import { Scissors, Merge, Type, Minimize2, RotateCw, PenTool } from 'lucide-react';

const tools = [
  { slug: 'edit-pdf', label: 'Edit PDF', icon: Type },
  { slug: 'merge-pdf', label: 'Merge PDF', icon: Merge },
  { slug: 'split-pdf', label: 'Split PDF', icon: Scissors },
  { slug: 'compress-pdf', label: 'Compress PDF', icon: Minimize2 },
  { slug: 'rotate-pdf', label: 'Rotate PDF', icon: RotateCw },
  { slug: 'add-signature', label: 'Sign PDF', icon: PenTool },
];

const HomePage = () => {
  const navigate = useNavigate();

  const handleUploadComplete = () => {
    navigate('/editor');
  };

  return (
    <>
      <SEO
        title="Free Online PDF Editor"
        description="PDF Studio Pro is the fastest PDF editor and converter. Easily edit text, annotate documents, add digital signatures, merge multiple files, and convert PDFs to JPG or Word. Ideal for business & students."
        keywords="pdf editor, edit pdf online, merge pdf, split pdf, compress pdf, add text to pdf, sign pdf, free pdf editor"
      />
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 flex flex-col">
          <UploadZone onUploadComplete={handleUploadComplete} />
        </div>

        {/* Tool links for SEO */}
        <section className="py-12 px-4 bg-muted/20 border-t border-border" data-testid="tool-links-section">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-base font-semibold text-center mb-6">All PDF Tools</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {tools.map(({ slug, label, icon: Icon }) => (
                <Link
                  key={slug}
                  to={`/tools/${slug}`}
                  className="flex items-center gap-2.5 p-3 rounded-lg border border-border hover:bg-card hover:shadow-sm transition-all text-sm"
                  data-testid={`tool-link-${slug}`}
                >
                  <Icon className="w-4 h-4 text-primary shrink-0" />
                  {label}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Structured data for SEO */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "PDF Studio Pro: Edit & Sign PDFs",
          "description": "Free PDF editor. Merge, split, compress & convert to Word/Excel.",
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Any",
          "offers": [
            { "@type": "Offer", "price": "0", "priceCurrency": "USD", "description": "Free — 1 download/day" },
            { "@type": "Offer", "price": "19", "priceCurrency": "USD", "description": "Lifetime unlimited access" },
          ],
        })}} />
      </div>
    </>
  );
};

export default HomePage;
